import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import wishlistService from '../../api/wishlist.service';

export const fetchWishlist = createAsyncThunk(
  'wishlist/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await wishlistService.getAllWishlistItems();
      const simplifiedData = response.data.map(item => ({
        id: item.id,
        item_id: item.item_id,
        item_type: item.item_type
      }));

      return simplifiedData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const toggleWishlistItem = createAsyncThunk(
  'wishlist/toggle',
  async ({ id, type }, { getState, rejectWithValue }) => {
    try {
      const { wishlist } = getState();
      const existingItem = wishlist.items.find(
        item => item.item_id === id && item.item_type === type
      );

      if (existingItem) {
        await wishlistService.deleteWishlistItem(existingItem.id);
        return {id:existingItem.id, item_type:existingItem.type, item_id:existingItem.item_id};
      } else {
        const response = await wishlistService.createWishlistItem({ item_id: id, item_type: type });
        return { item_id: id, item_type: type, id:response.data.id };
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const removeWishlistItem = createAsyncThunk(
  'wishlist/remove',
  async ({ id }, { getState, rejectWithValue }) => {
    try {
      const { wishlist } = getState();
      const existingItem = wishlist.items.find(
        item => item.id === id
      );
      return existingItem.id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    items: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWishlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchWishlist.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchWishlist.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })


      .addCase(toggleWishlistItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(toggleWishlistItem.fulfilled, (state, action) => {
        const item = action.payload;
        if (item) {
          const existingItemIndex = state.items.findIndex(
            wishlistItem => wishlistItem.id === item.id
          );
          if (existingItemIndex === -1) {
            state.items = [...state.items, item];
          } else {
            state.items = state.items.filter(itm => itm.id !== item.id);
          }
        }
        state.loading = false;
      })
      .addCase(toggleWishlistItem.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })

      .addCase(removeWishlistItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeWishlistItem.fulfilled, (state, action) => {
        state.items = state.items.filter(item => item.id !== action.payload);
        state.loading = false;
      })
      .addCase(removeWishlistItem.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  }
});

export default wishlistSlice.reducer;